import '../../CommonStyles.scss';
import { useGetOrganizationsSummary, useGetStudentsCount } from 'queryHooks/Admin/analytics';
import KpiCard from '../../components/KpiCard/KpiCard';
import { NoData } from '../../components/NoData/NoData';
import { OrganizationsBreakdown } from '../../components/OrganizationsBreakdown/OrganizationsBreakdown';
import { StudentsByOrganizationChartCard } from '../../components/StudentsByOrganizationChart/StudentsByOrganizationChart';

export const OrganizationTab = () => {
  const { data: organizations, isLoading: organizationsLoading, isError: organizationsError } = useGetOrganizationsSummary();
  const { data: studentsCount, isLoading: studentsLoading, isError: studentsError } = useGetStudentsCount();

  return (
    <div className='analytics-tab'>
      {organizationsError || studentsError || organizationsLoading || studentsLoading || (!organizations?.length && !studentsCount) ? (
        <NoData
          loading={organizationsLoading || studentsLoading}
          error={organizationsError || studentsError}
          noData={!organizations?.length && !studentsCount}
        />
      ) : (
        <>
          <div className='overview-section'>
            <div className='section-grid metrics'>
              <KpiCard label='Total Organizations' sources={['DB']} value={organizations?.length ?? 0} />
              <KpiCard label='Total Students' sources={['DB']} value={studentsCount ?? 0} />
              <KpiCard
                label='Avg. Students per Organization'
                sources={['DB']}
                value={organizations && studentsCount ? (studentsCount / organizations.length).toFixed(2) : 0}
              />
            </div>
          </div>

          <div className='overview-section'>
            <div className='section-grid trends'>
              <StudentsByOrganizationChartCard />
            </div>
          </div>

          <div className='overview-section'>
            <OrganizationsBreakdown />
          </div>
        </>
      )}
    </div>
  );
};
